<template>
    <el-dialog
               :before-close="handleClickPurchaseDetailCancel"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :visible.sync="purchaseDetailDialog"
               append-to-body
               class="custom_form_dialog purchase_detail_dialog"
               title="订单代采"
               width="620px">
        <el-form ref="purchaseForm"
                 :model="purchaseForm"
                 class="custom_detail_form"
                 label-position="top"
                 size="small">
            <el-form-item>
                <ul class="purchase_table_list">
                    <li v-for="(item,index) in purchaseForm.purchase_details" class="purchase_details_item">
                        <div class="purchase_details_item_index">
                            <span v-text="'代采' + (index+1)"></span>
                        </div>
                        <div class="purchase_details_item_content">
                            <el-form :model="item"
                                     label-position="top"
                                     size="small">
                                <el-form-item label="供应商（个人或公司名称）" prop="supplier">
                                    <span v-text="item.supplier"></span>
                                </el-form-item>
                                <ul class="goods_details_list">
                                    <li v-for="(goods,goods_index) in item.goods_details"
                                        class="goods_details_item">
                                        <div class="goods_details_index" v-text="'产品明细' + (goods_index+1)"></div>
                                        <div class="goods_details_content">
                                            <el-form :model="goods"
                                                     label-position="top"
                                                     size="small">
                                                <el-form-item label="产品名称" prop="goods_name">
                                                    <span v-text="goods.goods_name"></span>
                                                </el-form-item>
                                                <el-form-item label="单价" prop="price">
                                                    <span v-text="'¥'+goods.price"></span>
                                                </el-form-item>
                                                <el-form-item label="数量" prop="num">
                                                    <span v-text="goods.num"></span>
                                                </el-form-item>
                                                <el-form-item label="产品总价" prop="subtotal_price">
                                                    <span v-text="'¥'+goods.subtotal_price"></span>
                                                </el-form-item>
                                            </el-form>
                                        </div>
                                    </li>
                                </ul>
                            </el-form>
                        </div>
                    </li>
                </ul>
            </el-form-item>
            <el-form-item label="代采产品总金额" prop="total_price">
                <span v-text="'¥'+purchaseForm.total_price"></span>
            </el-form-item>
            <el-form-item label="总优惠金额" prop="discount_price">
                <span v-text="'¥'+purchaseForm.discount_price"></span>
            </el-form-item>
            <el-form-item label="实际代采总金额">
                <span v-text="'¥'+purchaseForm.actual_total_price"></span>
            </el-form-item>
            <el-form-item label="备注" prop="remarks">
                <span v-text="purchaseForm.remarks?purchaseForm.remarks:'--'"></span>
            </el-form-item>
            <el-form-item v-if="purchaseForm.file.length" label="附件">
                <div class="file_upload_wrap">
                    <ul class="upload_file_list">
                        <li v-for="(file,file_idx) in purchaseForm.file" class="upload_file_item">
                            <div class="file_left_wrap">
                                <img alt="" class="file_img"
                                     src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png">
                                <div class="file_info_wrap">
                                    <p class="file_name" v-text="file.file_name"></p>
                                    <p class="file_size" v-text="file.file_size"></p>
                                </div>
                            </div>
                            <div class="file_right_wrap">
                                <el-tooltip content="预览"
                                            effect="dark"
                                            placement="top">
                                            <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                <i class="iconfont icon-yanjing"></i>
                                            </span>
                                </el-tooltip>
                                <span class="line"></span>
                                <el-tooltip content="下载"
                                            effect="dark"
                                            placement="top">
                                            <span class="handle_icon_wrap"
                                                  @click="handleClickDownloadFile(file)">
                                                <i class="iconfont icon-daochu"></i>
                                            </span>
                                </el-tooltip>
                            </div>
                        </li>
                    </ul>
                </div>
            </el-form-item>
        </el-form>
        <div v-if="purchaseForm.order_price_change.length">
            <div class="page_little_title">
                <span class="title">订单金额变更信息</span>
                <span class="hint"> 审批通过后（无需审批请忽略），以下订单金额将变更</span>
            </div>
            <ul class="order_price_change_list">
                <li v-for="item in purchaseForm.order_price_change" class="order_price_change_item">
                    <div class="field_name" v-text="item.field_name"></div>
                    <div>
                        <span class="value_text" v-text="item.old_value.text?'¥' + item.old_value.text:'--'"></span>
                        <i class="iconfont icon-youjiantou"></i>
                        <span class="value_text" v-text="'¥' + item.new_value.text"></span>
                    </div>
                </li>
            </ul>
        </div>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc"  style="display:none"></el-image>
    </el-dialog>
</template>
<script>
import {purchaseDetails} from "@/api/index.js"
import {getOSSData, uploadImg} from "@/utils/uploadOss";
export default {
    name: "OrderPurchaseDetail",
    components: {

    },
    props: {
        purchaseDetailDialog: {
            type: Boolean,
            default: false
        },
        orderPurchaseId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading: false,
            purchaseForm: {
                total_price: '',
                actual_total_price: '',
                discount_price: '',
                remarks: '',
                file: [],
                purchase_details: [
                    {
                        supplier: '',
                        goods_details: [
                            {
                                goods_name: '',
                                price: '',
                                num: undefined,
                                subtotal_price: ''
                            }
                        ],
                        total_amount: ''
                    }
                ],
                order_price_change: [],
                node_list: []
            },
            previewImgList: [],
            previewImgSrc: ''
        }
    },
    created() {
        if( this.orderPurchaseId){
            this.getPurchaseDetail()
        }
    },
    methods: {

        //点击代采详情
        getPurchaseDetail() {
            this.loading = true
            purchaseDetails({
                order_purchase_id: this.orderPurchaseId
            }).then(res => {
                if (res.code === 200) {
                    this.purchaseForm.total_price = res.data.total_price
                    this.purchaseForm.actual_total_price = res.data.actual_total_price
                    this.purchaseForm.discount_price = res.data.discount_price
                    this.purchaseForm.remarks = res.data.remarks
                    this.purchaseForm.file = res.data.file
                    this.purchaseForm.purchase_details = res.data.purchase_details
                }
                this.loading = false
            })
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes('image')) {
                this.previewImgList = [file.file_path]
                this.previewImgSrc = file.file_path
                this.$refs.preview_img.showViewer = true
            } else {
                if (file.file_type.includes('pdf')) {
                    window.open(file.file_path)
                } else {
                    this.$message.error('当前文件格式不支持预览，请下载后查看')
                }
            }
        },

        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        //点击关闭代采详情
        handleClickPurchaseDetailCancel() {
            this.$emit("update:purchaseDetailDialog", false)
        },

    }
}
</script>
<style lang="scss" scoped>
.purchase_detail_dialog {
    ::v-deep .el-dialog {
        height: 720px;

        .el-dialog__body {
            padding: 16px 24px;
        }
    }
}
</style>
